export default __webpack_public_path__ + "static/media/promo.9e7269bf.svg";